import { render, staticRenderFns } from "./CreateLocation.vue?vue&type=template&id=53774863&scoped=true&"
import script from "./CreateLocation.vue?vue&type=script&lang=js&"
export * from "./CreateLocation.vue?vue&type=script&lang=js&"
import style0 from "./CreateLocation.vue?vue&type=style&index=0&id=53774863&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53774863",
  null
  
)

export default component.exports